import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserCredentialStore {
  private email: string;
  private displayEmail: string;
  private expiredPassword: string;
  private password: string;
  private readonly emailRegex: RegExp =
    /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

  public setEmail(email: string): void {
    this.email = email;
  }

  public getEmail(): string {
    return this.email;
  }

  public setDisplayEmail(displayEmail: string): void {
    this.displayEmail = displayEmail;
  }

  public getDisplayEmail(): string {
    return this.displayEmail;
  }

  public isEmailValid(text: string): boolean {
    return this.emailRegex.test(text);
  }

  public setExpiredPassword(password: string): void {
    this.expiredPassword = password;
  }

  public getExpiredPassword(): string {
    return this.expiredPassword;
  }

  public isExpiredPasswordSet(): boolean {
    return Boolean(this.expiredPassword);
  }

  public setPassword(password: string): void {
    this.password = password;
  }

  public getPassword(): string {
    return this.password;
  }
}
